(function () {
  var menuCopy = {
    en: { road: 'Road Wheels', gravel: 'Gravel Wheels', mtb: 'MTB Wheels', frame: 'Bicycle Frame', about: 'About Us', affiliate: 'Affiliate', blog: 'Blog', home: 'TOCCAY home', close: 'Close menu', nav: 'Mobile navigation' },
    de: { road: 'Rennrad-Laufräder', gravel: 'Gravel-Laufräder', mtb: 'MTB-Laufräder', frame: 'Fahrradrahmen', about: 'Über uns', affiliate: 'Partnerprogramm', blog: 'Blog', home: 'TOCCAY Startseite', close: 'Menü schließen', nav: 'Mobile Navigation' },
    es: { road: 'Ruedas de carretera', gravel: 'Ruedas de gravel', mtb: 'Ruedas de MTB', frame: 'Cuadro de bicicleta', about: 'Sobre nosotros', affiliate: 'Afiliados', blog: 'Blog', home: 'Inicio de TOCCAY', close: 'Cerrar menú', nav: 'Navegación móvil' },
    fr: { road: 'Roues de route', gravel: 'Roues gravel', mtb: 'Roues VTT', frame: 'Cadre de vélo', about: 'À propos', affiliate: 'Affiliation', blog: 'Blog', home: 'Accueil TOCCAY', close: 'Fermer le menu', nav: 'Navigation mobile' },
    ja: { road: 'ロードホイール', gravel: 'グラベルホイール', mtb: 'MTBホイール', frame: 'バイクフレーム', about: 'TOCCAYについて', affiliate: 'アフィリエイト', blog: 'ブログ', home: 'TOCCAYホーム', close: 'メニューを閉じる', nav: 'モバイルナビゲーション' }
  };
  function currentLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
    if (menuCopy[lang]) return lang;
    var match = window.location.pathname.match(/^\/(de|es|fr|ja)(?:\/|$)/);
    return match ? match[1] : 'en';
  }
  function localePrefix() {
    var locale = currentLocale();
    return locale === 'en' ? '' : '/' + locale;
  }
  function currentLinks() {
    var t = menuCopy[currentLocale()] || menuCopy.en;
    var prefix = localePrefix();
    return [
      { label: t.road, href: prefix + '/collections/road-bicycles-wheels' },
      { label: t.gravel, href: prefix + '/collections/gravel-carbon-wheel' },
      { label: t.mtb, href: prefix + '/collections/mtb-wheels' },
      { label: t.about, href: prefix + '/pages/about-us' },
      { label: t.affiliate, href: 'https://toccaycycling.goaffpro.com' },
      { label: t.blog, href: prefix + '/blogs/news' }
    ];
  }
  function homeHref() {
    return localePrefix() || '/';
  }
  function escapeHtml(value) {
    return String(value).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }
  function makeMenu() {
    var overlay = document.getElementById('codex-mobile-nav-overlay');
    var panel = document.getElementById('codex-mobile-nav');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'codex-mobile-nav-overlay';
      overlay.className = 'codex-mobile-nav-overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeMenu);
    }
    if (!panel) {
      panel = document.createElement('aside');
      panel.id = 'codex-mobile-nav';
      panel.className = 'codex-mobile-nav';
      panel.setAttribute('aria-hidden', 'true');
      document.body.appendChild(panel);
    }
    var labels = menuCopy[currentLocale()] || menuCopy.en;
    panel.innerHTML = '<div class="codex-mobile-nav__head"><a class="codex-mobile-nav__brand" href="' + homeHref() + '" aria-label="' + escapeHtml(labels.home) + '"><img src="' + escapeHtml(window.__TOCCAY_MENU_LOGO_ASSET__ || '') + '" alt="TOCCAY" loading="eager"></a><button class="codex-mobile-nav__close" type="button" aria-label="' + escapeHtml(labels.close) + '">&times;</button></div><nav class="codex-mobile-nav__links" aria-label="' + escapeHtml(labels.nav) + '">' + currentLinks().map(function (item) { return '<a href="' + escapeHtml(item.href) + '">' + escapeHtml(item.label) + '</a>'; }).join('') + '</nav><div class="codex-mobile-nav__support"><a href="mailto:support@toccaycycling.com">support@toccaycycling.com</a></div>';
    var closeButton = panel.querySelector('.codex-mobile-nav__close');
    if (closeButton) closeButton.addEventListener('click', closeMenu);
  }
  function openMenu(event) {
    if (window.matchMedia && !window.matchMedia('(max-width: 1024px)').matches) return;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    makeMenu();
    document.body.classList.remove('menu_open');
    document.documentElement.classList.add('codex_menu_open');
    document.body.classList.add('codex_menu_open');
    var overlay = document.getElementById('codex-mobile-nav-overlay');
    var panel = document.getElementById('codex-mobile-nav');
    if (overlay) overlay.style.display = 'block';
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
      panel.style.visibility = 'visible';
      panel.style.transform = 'translateX(0)';
    }
  }
  function closeMenu(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    document.body.classList.remove('menu_open');
    document.documentElement.classList.remove('codex_menu_open');
    document.body.classList.remove('codex_menu_open');
    var panel = document.getElementById('codex-mobile-nav');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.style.transform = '';
    }
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.mobileMenu-toggle, [data-mobile-menu], .item__mobile--hamburger button, summary.header__icon--menu, header-menu button, menu-drawer summary');
    if (trigger) openMenu(event);
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu(event);
  });
  var observer = new MutationObserver(function () {
    if (!document.body.classList.contains('menu_open')) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 1024px)').matches) return;
    window.setTimeout(function () {
      if (document.body.classList.contains('menu_open')) openMenu();
    }, 80);
  });
  function normalizeSearchLinks() {
    document.querySelectorAll('[data-search-mobile], [data-codex-search-link]').forEach(function (item) {
      item.setAttribute('href', (localePrefix() || '') + '/search');
      item.removeAttribute('aria-disabled');
      if (item.getAttribute('role') === 'link') item.removeAttribute('role');
    });
  }
  document.addEventListener('click', function (event) {
    var searchLink = event.target.closest && event.target.closest('[data-search-mobile], [data-codex-search-link]');
    if (!searchLink) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = (localePrefix() || '') + '/search';
  }, true);
  function loadJaLocalization() {
    try {
      if (!currentLocale() === 'ja' || window.__TOCCAY_JA_V20260702_LOADED__) return;
      window.__TOCCAY_JA_V20260702_LOADED__ = true;
      var s = document.createElement('script');
      s.src = 'https://cdn.shopify.com/s/files/1/0717/2502/3414/t/12/assets/codex-ja-localization-v20260702.js?v=' + Date.now();
      s.defer = true;
      document.head.appendChild(s);
    } catch (e) {}
  }
  function start() {
    makeMenu();
    normalizeSearchLinks();
    loadJaLocalization();
    if (document.body) observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
